
export class BaseProviderInstance {
  providerId: string;
  providerInstanceId: string;
}
